/**
 * 应用合并规则到表格数据
 * 
 * @param tableBody 表格数据体
 * @param columnIndex 需要合并的列索引
 * @param mergeRules 合并规则数组
 * @returns 处理后的表格数据
 */
export function applyMergeRules(
  tableBody: any[][],
  columnIndex: number,
  mergeRules: Array<{ startRow: number; rowSpan: number }>
): any[][] {
  // 创建一个新的表格数组，避免修改原始数据
  const result = JSON.parse(JSON.stringify(tableBody));

  // 应用每一条合并规则
  mergeRules.forEach((rule) => {
    const { startRow, rowSpan } = rule;

    // 将起始单元格转换为对象格式（如果不是）
    if (typeof result[startRow][columnIndex] !== "object") {
      result[startRow][columnIndex] = {
        text: result[startRow][columnIndex]
      };
    }

    // 设置rowSpan属性
    result[startRow][columnIndex].rowSpan = rowSpan;
    result[startRow][columnIndex].verticalAlignment = "middle"; // 垂直居中
    result[startRow][columnIndex].alignment = "left";

    // 根据合并单元格的行数，设置paddingTop，使其垂直居中
    if (rowSpan > 1) {
      // 假设每行高度为 12 ，文本高度为12
      const rowHeight = 12; // 每行的估计高度
      const contentHeight = 7; // 内容的估计高度
      const totalHeight = rowSpan * rowHeight;
      const paddingTop = Math.max(0, (totalHeight - contentHeight) / 2);

      // 设置内边距
      result[startRow][columnIndex].margin = [0, paddingTop, 0, 0];
    }

    // 将被合并的单元格设置为null
    for (let i = startRow + 1; i < startRow + rowSpan; i++) {
      result[i][columnIndex] = null;
    }
  });

  return result;
}
